export default "__VITE_ASSET__DFNc3lhW__"